import { useQuery } from '@tanstack/react-query'
import { httpClient } from './httpClient'

export const KEYS = {
  PRICING: 'pricing',
}

export const getPricing = async () => {
  const response = await httpClient.get('/features')
  return response.data
}
export const usePricing = (locale = 'en') =>
  useQuery([KEYS.PRICING, `locale=${locale}`], async () => getPricing(), {
    keepPreviousData: true,
  })
export const prefetchPricing = (queryClient, locale = 'en') =>
  queryClient.prefetchQuery([KEYS.PRICING, `locale=${locale}`], async () => getPricing())
